module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.addEntryToChat(false)
      }
    }
  }, [_vm._v("Add Entry")]), _vm._v(" "), _c('button', {
    staticClass: "button is-dark",
    on: {
      "click": function($event) {
        _vm.addEntryToChat(true)
      }
    }
  }, [_vm._v("Add Malicious Entry")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('chat-xss', {
    attrs: {
      "messages": _vm.messages
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("What was sent :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentMessage))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("XSS Basics")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.owasp.org/index.php/Cross-site_Scripting_(XSS)",
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_vm._v(" What is a XSS")]), _vm._v(" "), _c('p', [_vm._v("Injecting Raw Html is possible in the current frameworks. "), _c('br'), _vm._v("\n              React uses "), _c('a', {
    attrs: {
      "href": "https://facebook.github.io/react/docs/dom-elements.html#dangerouslysetinnerhtml"
    }
  }, [_vm._v("dangerouslySetInnerHTML")]), _c('br'), _vm._v("\n              Angular uses "), _c('a', {
    attrs: {
      "href": "https://angular.io/docs/ts/latest/guide/security.html#!#angular-s-cross-site-scripting-security-model"
    }
  }, [_vm._v("[innerHtml]")]), _c('br'), _vm._v("\n              Vue uses : "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/v2/guide/syntax.html#Raw-HTML"
    }
  }, [_vm._v("v-html")])]), _vm._v(" "), _c('p', [_vm._v("We will see how we can perform XSS in Vue and some possibles issues with current implementations.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2180fa47"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-feed.vue
// module id = 124
// module chunks = 1